import { render, staticRenderFns } from "./ProductModelDeleteModal.vue?vue&type=template&id=8291dab0&scoped=true&"
import script from "./ProductModelDeleteModal.vue?vue&type=script&lang=js&"
export * from "./ProductModelDeleteModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8291dab0",
  null
  
)

export default component.exports